// extracted by mini-css-extract-plugin
module.exports = {"benefits":"component-module--benefits--2O1Z0","container":"component-module--container--2c62F"};